import React, { createContext } from "react"

export interface ModalContextProps {
  isModalOpen: boolean
  openModal: (content: React.ReactNode, className?: string) => void
  closeModal: () => void
}

export const
  ModalContext = createContext<ModalContextProps>({
    isModalOpen: false,
    openModal: () => { },
    closeModal: () => { },
  })
